import { useCallback, useEffect, useState } from 'react';

export function useSparrowLocalStorage<T>(options: { key: string }): [T | undefined, (v: T | undefined) => void] {
  const { key } = options;
  const read = (): T | undefined => {
    try {
      const raw = localStorage.getItem(key);
      if (raw == null) return undefined;
      try {
        return JSON.parse(raw) as T;
      } catch {
        return raw as T;
      }
    } catch {
      return undefined;
    }
  };
  const [value, setValueState] = useState<T | undefined>(read);
  const setValue = useCallback(
    (v: T | undefined) => {
      setValueState(v);
      if (v === undefined || v === null) {
        localStorage.removeItem(key);
      } else if (typeof v === 'string') {
        localStorage.setItem(key, v);
      } else {
        localStorage.setItem(key, JSON.stringify(v));
      }
    },
    [key],
  );
  useEffect(() => {
    const onStorage = (e: StorageEvent) => {
      if (e.key === key) setValueState(read());
    };
    window.addEventListener('storage', onStorage);
    return () => window.removeEventListener('storage', onStorage);
  }, [key]);
  return [value, setValue];
}

export { useSparrowLocalStorage as useLocalStorage };
